import Spinner from 'react-bootstrap/Spinner';

function VariantsExample() {
  return (
    <>
      
      <Spinner animation="grow" variant="warning" />
      
      
    </>
  );
}

export default VariantsExample;